export default __webpack_public_path__ + "2480ebffbc5f6cee8209a8a1269353b8.png";